import * as React from "react"
import { BnbRoom, BnbRoomInclusion, BnbRoomTranslation } from "../../../types/types";

import * as Immutable from 'immutable'
import { snakeCase } from "lodash";
import { NumbersOf, typeProperties, BooleansOf } from "../../../utils/types";
import ReadMore from "../../shared/advert/ReadMore";
import Slider, { Settings } from "react-slick";

import 'slick-carousel/slick/slick.css'
type Props = {
  room: BnbRoom
  translation: BnbRoomTranslation
}

const BooleanProperties : () => BooleansOf<BnbRoom>[] = () => [
  'hasInternet',
  'hasTerrace',
  'hasTv',
  'hasCoffeeAndTea',
  'hasDvd',
  'hasRadio',
  'hasTelephone',
  'cdPlayer',
]

const GetNumberProperties : () => NumbersOf<BnbRoom>[] = () => [
  'maxPersons',
  'twinBeds',
  'singleBeds'
]

const InclusionLabel = (room: BnbRoom, attribute: keyof typeProperties<BnbRoom, BnbRoomInclusion>) => (
  `${I18n.t(`bnb_rooms.display.attributes.${snakeCase(attribute)}`)} ${I18n.t(`bnb_rooms.options.${room[attribute]}`)}`
)

const MaybeInclusionLi : (room: BnbRoom, attribute: keyof typeProperties<BnbRoom, BnbRoomInclusion>) => JSX.Element = (room, attribute) => (
  room[attribute] != 'not' ?
    <li className="features__item">
      {InclusionLabel(room, attribute)}
    </li>
  : <></>
)


export default (props: Props): JSX.Element => {
  const photos = props.room.photobookPhotos.nodes

  return <div className="box box--bb room" id={`room_${props.room.id}`}>
    <h3 className="box__title">
      {props.room.name}
    </h3>
    {
      photos.length > 0 ?

        <Slider
          dots={false}
          infinite={true}
          speed={500}
          slidesToShow={Math.min(photos.length, 3)}
          slidesToScroll={1}
          lazyLoad={"ondemand"}
          prevArrow={<div><div className='icon-back arrow-prev owl-prev'></div></div>}
          nextArrow={<div><div className='icon-next arrow-next owl-next'></div></div>}
          responsive={[
            {
              breakpoint: 700,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 450,
              settings: {
                slidesToShow: 1,
              }
            },
          ]}
        >
          {
            Immutable.List(photos).map(x =>
              <div className="slide" key={x.image.url}>
                <img src={x.image.url} />
              </div>
            )
          }
        </Slider>
        : <></>
    }

    <ul className="features features--compact features--three-col">
      {
        Immutable.OrderedSet(GetNumberProperties()).filter(x => props.room[x] > 0).map(x => (
          <li key={x} className="features__item">
            {I18n.t(`bnb_rooms.display.attributes.${snakeCase(x)}`, { count: props.room[x] })}
          </li>
        ))
      }

      {MaybeInclusionLi(props.room, 'hasBathAndShower')}

      {
        props.room.hasBathAndShower != 'in_room' ?
          <>
            {MaybeInclusionLi(props.room, 'hasBath')}
            {MaybeInclusionLi(props.room, 'hasShower')}
          </>
          : <></>
      }

      {MaybeInclusionLi(props.room, 'hasToilet')}
      {MaybeInclusionLi(props.room, 'hasSink')}
      {
        Immutable.OrderedSet(BooleanProperties()).filter(x => props.room[x]).map(x =>
          <li key={x} className="features__item">
            {I18n.t(`bnb_rooms.display.attributes.${snakeCase(x)}`)}
          </li>
        )
      }
    </ul>
    <div className="content-part">
      <div className="description">
        <ReadMore height={91}>
          <p>
            {!!props.translation ? props.translation.description : ''}
          </p>
        </ReadMore>
      </div>
    </div>
  </div>
}
